module.exports = __webpack_public_path__ + "img/bg_score_01.e8992296.jpg";